import { createFromIconfontCN } from '@ant-design/icons';

const Icon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_4212825_3i9ils4y94n.js', // 在 iconfont.cn 上生成
});

export default Icon;
